export interface Testimonial {
  name: string;
  role: string;
  company: string;
  testimonial: string | string[];
  avatar: string;
}

export const testimonials: Testimonial[] = [
  {
    name: "Glen DeBiasa",
    role: "Senior Software Engineer",
    company: "Nordstrom",
    testimonial: [
      "Christopher is an excellent engineer, and I was privileged to have him on my team… He dove right in, learning whatever he could… There was no ticket he wouldn’t pick up and tackle, whether it required Swift, Ruby, or New Relic… Given the opportunity, I would happily work with him again.",
    ],
    avatar: "Glen",
  },
  {
    name: "Kent Lottis",
    role: "Senior Software Engineer",
    company: "Nordstrom",
    testimonial:
      "Christopher is an enterprising and talented engineer, but also a courageous, kind, and engaging human being… He regularly extends himself beyond his immediate role, stepping into problem spaces and finding ways to contribute… He developed a reputation as one of the most kind-hearted and helpful people on our team… I would be delighted to work with him again should the opportunity arise.”",
    avatar: "Kent",
  },
  {
    name: "Sam Violette",
    role: "VP of Product Management",
    company: "Nordstrom",
    testimonial:
      "Christopher distinguished himself as engineer, designing novel approaches to solve problems and consistently delivering high-quality work in a timely manner. More importantly, Christopher epitomized the phrase “team player.” He was well-liked, cared about teaching others, rotated between squads to help when needed, and left behind dozens of teammates and managers who viewed him with great aﬀection and admiration.",
    avatar: "Sam",
  },
  {
    name: "Tony Merritt",
    role: "Director of Operations",
    company: "ISoft Data Systems",
    testimonial:
      "Christopher is a really self motivated developer that holds himself to a high standard and finishes projects on time, well tested, and with the end user in mind. He's both intuitive and task driven. He has full stack senior dev chops and is a great citizen and leader in a development shop. His humor and wit make him a pleasure to work with, in addition to being a whiz at his craft! A gentleman and a scholar.",
    avatar: "Tony",
  },
  {
    name: "Keith Wichert",
    role: "Software Developer",
    company: "Ultimus Fund Solutions",
    testimonial:
      "Christopher was a joy to work with! He learns fast and is very capable of working in groups or individually. His skill level is very good with PHP and React, as he was contributing heavily to the team's infrastructure, even as an intern. His work with the web version of the ticket tracker had a huge ROI. And while his skill level is excellent, Christopher's best ability is positive attitude. He keeps a smile on his face even when making his way through thousands of lines of cryptic PHP.",
    avatar: "Keith",
  },
];
